import CustomElement from '../core/custom.js'
import Emitter from '../core/emitter.js'
import Viewport from '../stores/viewport.js'
import debounce from '../utilities/debounce.js'
import getOffsetTop from '../utilities/getOffsetTop.js'

export default window.customElements.define(
  'keep-scrolling',
  class extends CustomElement {
    constructor() {
      super()

      this._linkShow = false
      this._offsetTop = 0

      this.onScroll = this.onScroll.bind(this)
      this.onScrolled = debounce(this.onScrolled.bind(this), 300)

      this._onResize = this.onResize.bind(this)
      this._onUpdate = this.onUpdate.bind(this)
    }

    connectedCallback() {
      super.connectedCallback()
      this.setData({ scrolling: false })

      //       this.observer = new IntersectionObserver(
      //         ([entry]) => {
      //           if (onBottom) {
      //             entry.target.classList.toggle(
      //               'is-active',
      //               entry.isIntersecting &&
      //                 entry.intersectionRect.bottom >= Viewport.height
      //             )
      //           } else {
      //             entry.target.classList.toggle('is-active', entry.isIntersecting)
      //           }
      //         },
      //         {
      //           rootMargin: '0px',
      //           threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1]
      //         }
      //       )
      //
      //       this.observer.observe(this)

      document.addEventListener('scroll', this.onScroll)

      this.onResize()

      Emitter.on('resize', this._onResize)
      Emitter.on('update', this._onUpdate)
    }

    disconnectedCallback() {
      super.disconnectedCallback()

      // this.observer.disconnect()

      document.removeEventListener('scroll', this.onScroll)

      Emitter.off('resize', this._onResize)
      Emitter.off('update', this._onUpdate)
    }

    onScroll() {
      this.setData({ scrolling: true })
      this.onScrolled()
    }

    onScrolled() {
      this.setData({ scrolling: false })
      this.onResize()
    }

    toggleShow(show) {
      this._linkShow = show
      this.classList.toggle('is-active', show)
    }

    onResize() {
      this._offsetTop = getOffsetTop(this)
      this._offsetHeight = this.offsetHeight
    }

    onUpdate() {
      if (this.scrolling) return

      if (
        window.scrollY >= this._offsetTop &&
        window.scrollY <  this._offsetTop + this._offsetHeight
      ) {
        if (this._linkShow !== true) {
          this.toggleShow(true)
        }
      } else {
        if (this._linkShow !== false) {
          this.toggleShow(false)
        }
      }
    }
  }
)
